import React, { createContext, useContext, useEffect } from 'react';
import posthog from 'posthog-js';
import { useAuth } from './AuthContext';

interface PostHogContextType {
  captureEvent: (event: string, properties?: Record<string, any>) => void;
  identifyUser: (userId: string, properties?: Record<string, any>) => void;
  resetUser: () => void;
}

const PostHogContext = createContext<PostHogContextType | undefined>(undefined);

export const PostHogProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user } = useAuth();

  // Identify user when they log in
  useEffect(() => {
    if (user?.id) {
      posthog.identify(user.id, {
        email: user.email,
      });
    } else {
      posthog.reset();
    }
  }, [user]);

  const captureEvent = (event: string, properties?: Record<string, any>) => {
    posthog.capture(event, properties);
  };

  const identifyUser = (userId: string, properties?: Record<string, any>) => {
    posthog.identify(userId, properties);
  };

  const resetUser = () => {
    posthog.reset();
  };

  return (
    <PostHogContext.Provider value={{ captureEvent, identifyUser, resetUser }}>
      {children}
    </PostHogContext.Provider>
  );
};

export const usePostHog = () => {
  const context = useContext(PostHogContext);
  if (context === undefined) {
    throw new Error('usePostHog must be used within a PostHogProvider');
  }
  return context;
};
